(function () {
    'use strict';

    angular
        .module('LayoutBuilder')
        .directive('lbCustomPanel', lbCustomPanelDirective);

    function lbCustomPanelDirective() {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                panel: "=",
                model: '=',
                content: '='
            },
            controller: lbCustomPanelDirectiveCtrl
        };
    }

    function lbCustomPanelDirectiveCtrl($scope, $element, $compile) {

        //angular.forEach(scope.panel.data.elements, function(element) {
        //    elem.append(element.html);
        //});
        this.$onInit = function() {
            $element.append($scope.panel.data.html);

            $compile($element.contents())($scope);
        }
    }
})();